export default function RoleIDMapping(RoleName) {
    if (RoleName === 'SuperAdmin') return '301';
    else if (RoleName === 'Underwriter') return '303';
    else if (RoleName === 'JuniorUnderwriter') return '313';
    else if (RoleName === 'ClaimManager') return '315';
    else if (RoleName === 'Broker') return '305';
    else if (RoleName === 'Insurer') return '308';
    else if (RoleName === 'Customer') return '311';
  }